import React, { useEffect, useState } from 'react';
import { Button, Input, Segment, Table, Header, Message, Form, Modal } from 'semantic-ui-react';
import LocalStorage from '../../../../lib/LocalStorage';
import config from '../../../../common/repository/config';
import { toast } from '../../../common/Toast';

interface StakeHolderRole {
  _id: string;
  name: string;
}

interface UpdateStakeHolderPageProps {
  selectedRole: StakeHolderRole;
  onClose: () => void;
  onUpdateSuccess: () => void;
}

const UpdateStackHolder: React.FC<UpdateStakeHolderPageProps> = ({
  selectedRole,
  onClose,
  onUpdateSuccess,
}) => {
  const [roles, setRoles] = useState<StakeHolderRole[]>([]);
  const [loading, setLoading] = useState(false);
  const [editingRoleId, setEditingRoleId] = useState<string | null>(null);
  const [roleName, setRoleName] = useState('');
  const [error, setError] = useState('');


  useEffect(() => {
    if (selectedRole) {
      setEditingRoleId(selectedRole._id);
      setRoleName(selectedRole.name);
      setError('');
    }
  }, [selectedRole]);

  const handleUpdate = async () => {
    if (!roleName.trim()) {
      setError('Role name cannot be empty.');
      return;
    }

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error('Authentication token is missing.');

      const response = await fetch(`${config.apiBaseURL}/stakeHolderRole/updateRole`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify({ roleId: editingRoleId, name: roleName }),
      });
      const result = await response.json();

      if (!response.ok) {
        toast.error(result?.message || 'Failed to update role');
        return;
      }

      toast.success(result?.message || 'Stakeholder role updated successfully');
      setEditingRoleId(null);
      setRoleName('');
      setError('');
      onUpdateSuccess();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error('Error updating role');
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <Modal open={true} onClose={onClose} size="small">
        <Modal.Header>Edit StakeHolder Role</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Input
              label="Role Name"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="blue" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Actions>
      </Modal>

    </div>
  );
};

export default UpdateStackHolder;
